<div class="flex flex-col gap-2 max-w-xl">
  <h3 class="font-semibold text-[15px] leading-[19px] text-[var(--text-color)]">{{
    'graphs.sections.measuresAndPosts' | transloco
  }}</h3>
  <ces-button-secondary
    icon="checklist"
    [label]="'common.dialogs.selectMeasures.title' | transloco"
    (onClick)="selectMeasures.emit()" />
  @if (sortedMeasures().length > 0) {
    <div class="flex flex-col">
      @for (measure of sortedMeasures(); track measure.id) {
        <app-graph-item-row
          [name]="measure.name"
          (configure)="configureMeasure.emit(measure)"
          (remove)="removeMeasure.emit(measure)" />
      }
    </div>
  }
</div>
